export interface Flight {
  id: string;
  duffelOfferId?: string;
  airline: string;
  airlineCode: string;
  airlineColor: string;
  from: string;
  fromCode: string;
  to: string;
  toCode: string;
  departure: string;
  arrival: string;
  durationMin: number;
  stops: number;
  stopCity?: string;
  price: number;
  currency: string;
  originalPrice?: number;
  seatsLeft?: number | null;
  type: "domestic" | "international";
  baggage: string;
  refundable: boolean;
  aircraft: string;
  flightNumber?: string;
}

export const AIRPORTS: Record<string, { city: string; country: string; code: string }> = {
  KHI: { city: "Karachi", country: "Pakistan", code: "KHI" },
  LHE: { city: "Lahore", country: "Pakistan", code: "LHE" },
  ISB: { city: "Islamabad", country: "Pakistan", code: "ISB" },
  PEW: { city: "Peshawar", country: "Pakistan", code: "PEW" },
  UET: { city: "Quetta", country: "Pakistan", code: "UET" },
  MUX: { city: "Multan", country: "Pakistan", code: "MUX" },
  SKT: { city: "Sialkot", country: "Pakistan", code: "SKT" },
  DXB: { city: "Dubai", country: "UAE", code: "DXB" },
  AUH: { city: "Abu Dhabi", country: "UAE", code: "AUH" },
  RUH: { city: "Riyadh", country: "Saudi Arabia", code: "RUH" },
  JED: { city: "Jeddah", country: "Saudi Arabia", code: "JED" },
  DOH: { city: "Doha", country: "Qatar", code: "DOH" },
  KWI: { city: "Kuwait City", country: "Kuwait", code: "KWI" },
  LHR: { city: "London", country: "UK", code: "LHR" },
  CDG: { city: "Paris", country: "France", code: "CDG" },
  FRA: { city: "Frankfurt", country: "Germany", code: "FRA" },
  JFK: { city: "New York", country: "USA", code: "JFK" },
  ORD: { city: "Chicago", country: "USA", code: "ORD" },
  YYZ: { city: "Toronto", country: "Canada", code: "YYZ" },
  KUL: { city: "Kuala Lumpur", country: "Malaysia", code: "KUL" },
  BKK: { city: "Bangkok", country: "Thailand", code: "BKK" },
  SIN: { city: "Singapore", country: "Singapore", code: "SIN" },
  PEK: { city: "Beijing", country: "China", code: "PEK" },
  ORY: { city: "Oslo", country: "Norway", code: "ORY" },
  BCN: { city: "Barcelona", country: "Spain", code: "BCN" },
};

export const SEARCH_CITIES = [
  "Karachi (KHI)", "Lahore (LHE)", "Islamabad (ISB)", "Peshawar (PEW)",
  "Quetta (UET)", "Multan (MUX)", "Sialkot (SKT)",
  "Dubai (DXB)", "Abu Dhabi (AUH)", "Riyadh (RUH)", "Jeddah (JED)",
  "Doha (DOH)", "Kuwait City (KWI)", "London (LHR)", "Paris (CDG)",
  "Frankfurt (FRA)", "New York (JFK)", "Chicago (ORD)", "Toronto (YYZ)",
  "Kuala Lumpur (KUL)", "Bangkok (BKK)", "Singapore (SIN)", "Beijing (PEK)",
];

export const ALL_FLIGHTS: Flight[] = [
  // ---- DOMESTIC ----
  {
    id: "PK-101", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Karachi", fromCode: "KHI", to: "Lahore", toCode: "LHE",
    departure: "06:30", arrival: "08:00", durationMin: 90, stops: 0,
    price: 12500, currency: "PKR", originalPrice: 16000, seatsLeft: 4, type: "domestic",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 737",
  },
  {
    id: "PA-201", airline: "AirSial", airlineCode: "PF", airlineColor: "#c8102e",
    from: "Karachi", fromCode: "KHI", to: "Lahore", toCode: "LHE",
    departure: "09:15", arrival: "10:50", durationMin: 95, stops: 0,
    price: 10800, currency: "PKR", seatsLeft: 9, type: "domestic",
    baggage: "20 kg", refundable: false, aircraft: "Airbus A320",
  },
  {
    id: "ER-301", airline: "Serene Air", airlineCode: "ER", airlineColor: "#003087",
    from: "Karachi", fromCode: "KHI", to: "Lahore", toCode: "LHE",
    departure: "14:00", arrival: "15:40", durationMin: 100, stops: 0,
    price: 11200, currency: "PKR", originalPrice: 13500, type: "domestic",
    baggage: "20 kg", refundable: true, aircraft: "Boeing 737",
  },
  {
    id: "PK-105", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Karachi", fromCode: "KHI", to: "Islamabad", toCode: "ISB",
    departure: "07:00", arrival: "08:50", durationMin: 110, stops: 0,
    price: 13800, currency: "PKR", originalPrice: 18000, seatsLeft: 6, type: "domestic",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "PA-205", airline: "AirSial", airlineCode: "PF", airlineColor: "#c8102e",
    from: "Karachi", fromCode: "KHI", to: "Islamabad", toCode: "ISB",
    departure: "11:30", arrival: "13:25", durationMin: 115, stops: 0,
    price: 11900, currency: "PKR", type: "domestic",
    baggage: "20 kg", refundable: false, aircraft: "Airbus A320",
  },
  {
    id: "PK-401", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Lahore", fromCode: "LHE", to: "Karachi", toCode: "KHI",
    departure: "16:00", arrival: "17:30", durationMin: 90, stops: 0,
    price: 12000, currency: "PKR", type: "domestic",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 737",
  },
  {
    id: "ER-405", airline: "Serene Air", airlineCode: "ER", airlineColor: "#003087",
    from: "Islamabad", fromCode: "ISB", to: "Lahore", toCode: "LHE",
    departure: "13:00", arrival: "13:55", durationMin: 55, stops: 0,
    price: 8900, currency: "PKR", originalPrice: 10500, seatsLeft: 3, type: "domestic",
    baggage: "20 kg", refundable: false, aircraft: "Boeing 737",
  },
  {
    id: "PK-503", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Karachi", fromCode: "KHI", to: "Peshawar", toCode: "PEW",
    departure: "08:45", arrival: "11:15", durationMin: 150, stops: 1, stopCity: "Islamabad",
    price: 15200, currency: "PKR", originalPrice: 19000, type: "domestic",
    baggage: "23 kg", refundable: true, aircraft: "ATR-72",
  },
  {
    id: "PK-607", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Karachi", fromCode: "KHI", to: "Multan", toCode: "MUX",
    departure: "10:30", arrival: "11:45", durationMin: 75, stops: 0,
    price: 9800, currency: "PKR", seatsLeft: 7, type: "domestic",
    baggage: "23 kg", refundable: true, aircraft: "ATR-72",
  },
  {
    id: "ER-701", airline: "Serene Air", airlineCode: "ER", airlineColor: "#003087",
    from: "Lahore", fromCode: "LHE", to: "Islamabad", toCode: "ISB",
    departure: "19:00", arrival: "19:55", durationMin: 55, stops: 0,
    price: 7500, currency: "PKR", type: "domestic",
    baggage: "20 kg", refundable: false, aircraft: "Boeing 737",
  },

  // ---- INTERNATIONAL ----
  {
    id: "EK-601", airline: "Emirates", airlineCode: "EK", airlineColor: "#d71921",
    from: "Karachi", fromCode: "KHI", to: "Dubai", toCode: "DXB",
    departure: "02:15", arrival: "04:30", durationMin: 135, stops: 0,
    price: 42000, currency: "PKR", originalPrice: 55000, seatsLeft: 5, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "PK-201", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Karachi", fromCode: "KHI", to: "Dubai", toCode: "DXB",
    departure: "07:45", arrival: "10:05", durationMin: 140, stops: 0,
    price: 36800, currency: "PKR", type: "international",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "FZ-101", airline: "flydubai", airlineCode: "FZ", airlineColor: "#e87722",
    from: "Karachi", fromCode: "KHI", to: "Dubai", toCode: "DXB",
    departure: "12:20", arrival: "14:40", durationMin: 140, stops: 0,
    price: 31500, currency: "PKR", originalPrice: 38000, seatsLeft: 11, type: "international",
    baggage: "20 kg", refundable: false, aircraft: "Boeing 737 MAX",
  },
  {
    id: "QR-501", airline: "Qatar Airways", airlineCode: "QR", airlineColor: "#5c0632",
    from: "Lahore", fromCode: "LHE", to: "Doha", toCode: "DOH",
    departure: "03:10", arrival: "05:40", durationMin: 210, stops: 0,
    price: 58000, currency: "PKR", originalPrice: 72000, seatsLeft: 3, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Airbus A350",
  },
  {
    id: "SV-601", airline: "Saudi Arabian Airlines", airlineCode: "SV", airlineColor: "#006c35",
    from: "Karachi", fromCode: "KHI", to: "Riyadh", toCode: "RUH",
    departure: "01:30", arrival: "04:15", durationMin: 165, stops: 0,
    price: 44500, currency: "PKR", type: "international",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 787",
  },
  {
    id: "PK-305", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Lahore", fromCode: "LHE", to: "Riyadh", toCode: "RUH",
    departure: "22:00", arrival: "01:10", durationMin: 190, stops: 0,
    price: 40200, currency: "PKR", seatsLeft: 8, type: "international",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "BA-701", airline: "British Airways", airlineCode: "BA", airlineColor: "#075aaa",
    from: "Islamabad", fromCode: "ISB", to: "London", toCode: "LHR",
    departure: "22:30", arrival: "05:45", durationMin: 435, stops: 0,
    price: 185000, currency: "PKR", originalPrice: 230000, seatsLeft: 4, type: "international",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 787 Dreamliner",
  },
  {
    id: "PK-701", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Karachi", fromCode: "KHI", to: "London", toCode: "LHR",
    departure: "21:00", arrival: "06:30", durationMin: 450, stops: 1, stopCity: "Islamabad",
    price: 162000, currency: "PKR", type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "EK-401", airline: "Emirates", airlineCode: "EK", airlineColor: "#d71921",
    from: "Karachi", fromCode: "KHI", to: "London", toCode: "LHR",
    departure: "02:15", arrival: "12:40", durationMin: 805, stops: 1, stopCity: "Dubai",
    price: 192000, currency: "PKR", originalPrice: 245000, seatsLeft: 6, type: "international",
    baggage: "35 kg", refundable: true, aircraft: "Airbus A380",
  },
  {
    id: "MH-501", airline: "Malaysia Airlines", airlineCode: "MH", airlineColor: "#003087",
    from: "Karachi", fromCode: "KHI", to: "Kuala Lumpur", toCode: "KUL",
    departure: "09:00", arrival: "21:45", durationMin: 525, stops: 0,
    price: 96000, currency: "PKR", originalPrice: 118000, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Airbus A330",
  },
  {
    id: "TG-601", airline: "Thai Airways", airlineCode: "TG", airlineColor: "#4b3b8c",
    from: "Islamabad", fromCode: "ISB", to: "Bangkok", toCode: "BKK",
    departure: "11:30", arrival: "23:15", durationMin: 465, stops: 1, stopCity: "Lahore",
    price: 88500, currency: "PKR", type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "GF-301", airline: "Gulf Air", airlineCode: "GF", airlineColor: "#c8102e",
    from: "Lahore", fromCode: "LHE", to: "Abu Dhabi", toCode: "AUH",
    departure: "05:30", arrival: "08:20", durationMin: 230, stops: 0,
    price: 38900, currency: "PKR", originalPrice: 47000, seatsLeft: 12, type: "international",
    baggage: "23 kg", refundable: false, aircraft: "Airbus A321",
  },
  {
    id: "KU-201", airline: "Kuwait Airways", airlineCode: "KU", airlineColor: "#1e73c3",
    from: "Karachi", fromCode: "KHI", to: "Kuwait City", toCode: "KWI",
    departure: "14:00", arrival: "17:30", durationMin: 210, stops: 0,
    price: 41200, currency: "PKR", type: "international",
    baggage: "23 kg", refundable: true, aircraft: "Airbus A320",
  },
  {
    id: "LH-801", airline: "Lufthansa", airlineCode: "LH", airlineColor: "#05164d",
    from: "Karachi", fromCode: "KHI", to: "Frankfurt", toCode: "FRA",
    departure: "23:55", arrival: "08:30", durationMin: 1235, stops: 1, stopCity: "Dubai",
    price: 198000, currency: "PKR", originalPrice: 250000, seatsLeft: 2, type: "international",
    baggage: "23 kg", refundable: true, aircraft: "Airbus A350",
  },
  {
    id: "PK-801", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Islamabad", fromCode: "ISB", to: "New York", toCode: "JFK",
    departure: "20:30", arrival: "06:45", durationMin: 810, stops: 1, stopCity: "London",
    price: 285000, currency: "PKR", originalPrice: 340000, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 777",
  },

  // ---- NEW YORK ROUTES ----
  {
    id: "SV-901", airline: "Saudi Arabian Airlines", airlineCode: "SV", airlineColor: "#006c35",
    from: "New York", fromCode: "JFK", to: "Jeddah", toCode: "JED",
    departure: "22:15", arrival: "18:30", durationMin: 855, stops: 0,
    price: 320000, currency: "PKR", originalPrice: 410000, seatsLeft: 5, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 787 Dreamliner",
  },
  {
    id: "EK-902", airline: "Emirates", airlineCode: "EK", airlineColor: "#d71921",
    from: "New York", fromCode: "JFK", to: "Jeddah", toCode: "JED",
    departure: "11:45", arrival: "12:10", durationMin: 1105, stops: 1, stopCity: "Dubai",
    price: 298000, currency: "PKR", originalPrice: 375000, seatsLeft: 8, type: "international",
    baggage: "35 kg", refundable: true, aircraft: "Airbus A380",
  },
  {
    id: "QR-902", airline: "Qatar Airways", airlineCode: "QR", airlineColor: "#5c0632",
    from: "New York", fromCode: "JFK", to: "Jeddah", toCode: "JED",
    departure: "21:30", arrival: "20:45", durationMin: 975, stops: 1, stopCity: "Doha",
    price: 275000, currency: "PKR", originalPrice: 340000, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "TK-901", airline: "Turkish Airlines", airlineCode: "TK", airlineColor: "#c70a0a",
    from: "New York", fromCode: "JFK", to: "Jeddah", toCode: "JED",
    departure: "18:00", arrival: "22:30", durationMin: 1050, stops: 1, stopCity: "Istanbul",
    price: 252000, currency: "PKR", originalPrice: 320000, seatsLeft: 3, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Airbus A350",
  },
  // ---- JEDDAH → NEW YORK (RETURN) ----
  {
    id: "SV-902", airline: "Saudi Arabian Airlines", airlineCode: "SV", airlineColor: "#006c35",
    from: "Jeddah", fromCode: "JED", to: "New York", toCode: "JFK",
    departure: "09:00", arrival: "16:30", durationMin: 870, stops: 0,
    price: 315000, currency: "PKR", originalPrice: 400000, seatsLeft: 6, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 787 Dreamliner",
  },
  {
    id: "EK-903", airline: "Emirates", airlineCode: "EK", airlineColor: "#d71921",
    from: "Jeddah", fromCode: "JED", to: "New York", toCode: "JFK",
    departure: "03:20", arrival: "14:55", durationMin: 1115, stops: 1, stopCity: "Dubai",
    price: 292000, currency: "PKR", originalPrice: 370000, seatsLeft: 9, type: "international",
    baggage: "35 kg", refundable: true, aircraft: "Airbus A380",
  },
  {
    id: "QR-903", airline: "Qatar Airways", airlineCode: "QR", airlineColor: "#5c0632",
    from: "Jeddah", fromCode: "JED", to: "New York", toCode: "JFK",
    departure: "14:00", arrival: "21:10", durationMin: 990, stops: 1, stopCity: "Doha",
    price: 268000, currency: "PKR", originalPrice: 335000, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 777",
  },
  {
    id: "TK-902", airline: "Turkish Airlines", airlineCode: "TK", airlineColor: "#c70a0a",
    from: "Jeddah", fromCode: "JED", to: "New York", toCode: "JFK",
    departure: "07:15", arrival: "16:45", durationMin: 1080, stops: 1, stopCity: "Istanbul",
    price: 245000, currency: "PKR", originalPrice: 315000, seatsLeft: 4, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Airbus A350",
  },
  // ---- JEDDAH ↔ KARACHI / LAHORE ----
  {
    id: "SV-701", airline: "Saudi Arabian Airlines", airlineCode: "SV", airlineColor: "#006c35",
    from: "Karachi", fromCode: "KHI", to: "Jeddah", toCode: "JED",
    departure: "02:00", arrival: "04:50", durationMin: 170, stops: 0,
    price: 46000, currency: "PKR", originalPrice: 58000, seatsLeft: 7, type: "international",
    baggage: "30 kg", refundable: true, aircraft: "Boeing 787",
  },
  {
    id: "PK-702", airline: "Pakistan International Airlines", airlineCode: "PIA", airlineColor: "#006747",
    from: "Lahore", fromCode: "LHE", to: "Jeddah", toCode: "JED",
    departure: "23:00", arrival: "02:10", durationMin: 190, stops: 0,
    price: 42000, currency: "PKR", type: "international",
    baggage: "23 kg", refundable: true, aircraft: "Boeing 777",
  },
];
